import axios from "axios";
// import FormData from "form-data";
import { toast } from "react-toastify";
import Router from "next/router";
import { FORGOT_PASSWORD, FORGOT_PASSWORD_ERROR } from "../types";

export const forgotPassword = (e) => async (dispatch, getState) => {
  // console.log(e, '9090909')
  try {
    var data = new FormData();
    data.append("email", e.email);
    var config = {
      method: "post",
      url: `${process.env.NEXT_PUBLIC_API_URL}/forgetpassword`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    const res = await axios(config);
    // console.log(res);
    const { reset_token } = res?.data?.data;

    if (res.data.success) {
      toast.success(`Success, Please check your email and reset your password.`);
      dispatch({
        type: FORGOT_PASSWORD,
        payload: res.data,
      });
    }
  }
   catch (error) {
      toast.error("Invalid Email", {
        onClose: () => Router.push("/forgotpassword"),
      });
    toast.error(error.response.data, {
      onClose: () => Router.push("/forgotpassword"),
    });
    dispatch({
      type: FORGOT_PASSWORD_ERROR,
      payload: error.response,
    });
  }
};
